import React, { useState, useEffect } from 'react';
import apiConfig from '../config/apiConfig';
import './TickerFeed.css';

const TickerFeed = () => {
  const [tickerText, setTickerText] = useState(
    "Welcome to Legacy Reborn! A reimagining of a classic game world."
  );
  
  useEffect(() => {
    const fetchTickerMessages = async () => {
      try {
        const response = await fetch(apiConfig.tickerFeed, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data && data.ticker) {
            setTickerText(data.ticker);
          }
        } else {
          console.log('Using default ticker message');
        }
      } catch (error) {
        console.error('Error fetching ticker:', error);
      }
    };

    fetchTickerMessages();
    
    const interval = setInterval(fetchTickerMessages, 300000);
    return () => clearInterval(interval);
  }, []);
  
  // Add visual highlights to important parts of the text
  const enhanceText = (text) => {
    // Split by bullet separators
    const parts = text.split('•');
    // Join with highlighted bullet points and add some HTML formatting
    return parts.join(' <strong>★</strong> ');
  };
  
  // Format the text with enhanced styling
  const formattedText = enhanceText(`${tickerText} • `);
  
  return (
    <div className="ticker-feed">
      <div className="ticker-label">Ticker Feed</div>
      <div className="ticker-wrap">
        <div className="ticker-content">
          <div className="ticker-track">
            <span className="ticker-text" dangerouslySetInnerHTML={{ __html: formattedText }} />
            <span className="ticker-text" dangerouslySetInnerHTML={{ __html: formattedText }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TickerFeed;
